import { render, staticRenderFns } from "./amap.vue?vue&type=template&id=4481440c&"
import script from "./amap.vue?vue&type=script&lang=ts&"
export * from "./amap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports